import * as React from 'react';
import styled from 'styled-components';
import CloseIcon from '../icons/project-icons/Close';
import { ButtonTypes } from '../Button';

export type closeButtonVariant = 'standard';

const CloseButtonWrapper = styled.button`
  border: unset;
  margin: unset;
  background: unset;
  cursor: pointer;
  padding: 0 8px;
`;

export interface IBCloseButtonProps {
  type: ButtonTypes;
  onClick?(): any;
  className?: string;
  testId?: string;
}
const CloseButton: React.FC<IBCloseButtonProps> = (
  props: IBCloseButtonProps
) => {
  const { type, onClick, className, testId } = props;
  return (
    <CloseButtonWrapper
      data-testid={testId}
      className={`${className ?? ''}`}
      type={type}
      onClick={e => {
        e.preventDefault();
        if (onClick) {
          onClick();
        }
      }}
    >
      <CloseIcon width={8} />
    </CloseButtonWrapper>
  );
};

export default CloseButton;
